import { useTurnStore } from "@/features/tutor/store/useTurnStore";
import { useWebsocketStore } from "@/features/tutor/store/useWebsocketStore";
import { useNotepadStore } from "../store/useNotepadStore";

/** Persistent recovery for failures that automatic reconnect cannot resolve. */
export function CanvasConnectionRecovery() {
  const status = useNotepadStore((s) => s.connectionStatus);
  const retry = useNotepadStore((s) => s.retryConnection);
  const turnFailed = useTurnStore((s) => s.turnChangeFailed);
  if (status !== "exhausted" && status !== "session_lost" && !turnFailed)
    return null;

  const sessionLost = status === "session_lost";
  const recover = () => {
    if (sessionLost) {
      window.location.reload();
      return;
    }
    if (turnFailed) {
      if (useWebsocketStore.getState().wsConnected) {
        useTurnStore.getState().setTurnChangeFailed(false);
      } else {
        (window as Window & { wsReconnect?: () => void }).wsReconnect?.();
      }
    }
    if (status === "exhausted") retry?.();
  };
  return (
    <div
      role="alert"
      className="absolute left-4 right-4 top-4 z-[300] flex items-center justify-between gap-3 rounded-lg bg-white p-3 text-sm text-gray-900 shadow-lg"
    >
      <span>
        {sessionLost
          ? "Your lesson connection ended. Reload to continue."
          : turnFailed
            ? "Your request could not be sent. Try again, then repeat your request."
            : "The notepad could not reconnect."}
      </span>
      <button
        type="button"
        className="rounded border border-gray-400 px-3 py-1 font-medium focus-visible:outline focus-visible:outline-2"
        onClick={recover}
      >
        {sessionLost
          ? "Reload lesson"
          : turnFailed
            ? "Try again"
            : "Retry connection"}
      </button>
    </div>
  );
}
